/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

const common = {
  black: 'rgba(0,0,0,0.87)',
  white: '#FFFFFF',
  offWhite: '#FAFAFA',
};

export default common;
